module.exports = __webpack_public_path__ + "static/media/4_5.c94d14c9.jpg";